type Board = Boolean[][];
type Processed = Board[];
// type MadeUnsafe = number[][];
export default function NQueens(size: number, board: Board) {
  let processed: Processed = [];
  function solveNQueenUtil(board: Board, col: number) {
    processed.push(board.map((arr) => arr.slice()));
    let N = board.length;
    if (col >= N) return true;
    for (let i = 0; i < N; i++) {
      if (isSafe(board, i, col)) {
        board[i][col] = true;
        if (solveNQueenUtil(board, col + 1)) return true;
        board[i][col] = false;
      }
    }
    return false;
  }
  function isSafe(board: Board, row: number, col: number) {
    for (let i = 0; i < col; i++) {
      if (board[row][i] === true) return false;
    }
    for (let i = row, j = col; i >= 0 && j >= 0; i--, j--) {
      if (board[i][j] === true) return false;
    }
    for (let i = row, j = col; j >= 0 && i < board.length; i++, j--) {
      if (board[i][j] === true) return false;
    }

    return true;
  }
  solveNQueenUtil(board, 0);
  return { board, processed };
}
